import {  Center, Space, Text } from '@mantine/core'
import { DateTime } from 'luxon'
import { GetServerSideProps } from 'next'
import Head from 'next/head'
import Link from 'next/link'
import EmailSignupBanner from '../components/EmailSignupBanner'
import { MenuId } from '../components/Header'
import Layout from '../components/Layout'
import { VideoList } from '../components/Video'
import { getPlayLists } from '../lib/data'
import { PlayList, Video } from '../lib/definitions'
import styles from './playlists.module.scss'
import { AspectBox } from '../components/AspectBox'


export default function Videos({data} : {data: {playlists: PlayList[]}})
{
  
    return(

      <Layout menuId={MenuId.videos} hidePopUp={true}>

      <Head>
          <title>Playlists</title>
          <meta name="description" content='Sets of art videos from Raw Umber Studios'/>
      </Head>
      <div>
      <h1>Playlists</h1>
    <Text ta='center'>Is our extensive, searchable <Link href='/new-video-search'>video library</Link> a bit overwhelming? Try starting with these curated playlists of our favourite videos.</Text>
   
   <div className={styles.playlists}>
   {data.playlists.map(
        p=><div key={p.id} className={styles.playlist}>
            <div className={styles.playlistImage}>
              <AspectBox width={16} height={9}>
              {p.imageSlug && <a href={`/playlists/${p.slug}`}><img alt={p.description} src={`/n/api/wpimage?slug=${encodeURIComponent(p.imageSlug)}&w=840`}/></a>}
              </AspectBox>
            </div>
            <div className={styles.playlistText}>
        
            <div className={styles.playlistTitle}><Text><Link href={`/playlists/${p.slug}`}>{p.description}</Link></Text></div>
            <div className={styles.playlistDescription}><Text>{p.longDescription}</Text></div>
            </div>
            </div>
   )}
   </div>

   <Center>
      <Text fw='bold'>Not found exactly what you want? Try our <Link href='/new-video-search'>video search</Link> to search hundreds of videos by technique, subject matter, materials, and more.</Text>
      </Center>
      </div>
      <Space h="lg" />
      <EmailSignupBanner/>
    </Layout>
      );    

}



export const getServerSideProps : GetServerSideProps = async (context)=>
{
    

    let playlists = await getPlayLists();

    let entries = [...playlists.values()];

    let playlist = entries.sort((a,b) => ((a.sequence??0)-(b.sequence??0)));


    return {
      props: {
        data: 
        { 
          playlists: playlist
        }
      }
  }
  

}